module.exports = __webpack_public_path__ + "static/media/letmi.6ae64099.svg";